import { Fragment, useState } from "react";
import { attachClassNameToTag } from "../../../helpers/attachClassNameToTag";
import { formatMoney } from "../../../helpers/formatter";
import { Loader } from "../../../UI/Loaders/Loaders";
import Paginator from "../../Pagination/Pagination.component";
import useAutoPaidRepaymentdetails from "../../../custom-hooks/useAutoRepaymentDetails";
import CustomSelectDropdown from "../../CustomHTMLElements/CustomSelectDropdown";
import useAllAggregators from "../../../custom-hooks/useAllAggregators";
import { getTokenFromLocalStorage } from "../../../helpers/localStorage";
import { BASE_URL } from "../../../appConstants";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { appInsights } from "../../../config/appInsights";

function AutoRepaymentLoans() {
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [count, setCount] = useState(null);
  const [search, setSearch] = useState({
    PageSize: 20,
    Page: 1,
    Reference: "",
    Aggregator_Id: null,
    DateRepaidFrom: "",
    DateRepaidTo: "",
    RepaymentStatus: "",
  });
  const [presearch, setPresearch] = useState({
    Page: 1,
    PageSize: 20,
  });
  const { data, status, error } = useAutoPaidRepaymentdetails(presearch);
  if (data) {
    if (count === null) {
      setCount(data.totalCount);
    }
  }

  const { data: aggregatorData } = useAllAggregators();

  const handleDownload = (e) => {
    e.preventDefault();
    setDownloadLoading(true);

    let token = getTokenFromLocalStorage();

    const query = { ...search };

    Object.keys(query).map((item) => {
      if (
        query[item] === null ||
        query[item] === undefined ||
        query[item] === ""
      ) {
        delete query[item];
      }
    });

    fetch(
      BASE_URL +
        `${
          ajaxEndpoints.DOWNLOAD_ALL_PAID_REPAYMENT_DETAILS
        }?${new URLSearchParams(query)}`,
      {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: "Token " + token,
        },
      }
    )
      .then((response) => {
        setDownloadLoading(false);
        if (response.status === 200 || response.status === 201) {
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${`AutoRepamentLoans.csv`}`);
            link.click();
          });
        }

        if (response.status === 403 || response.status === 401) {
          localStorage.removeItem("sso_auth_token");
          this.props.history.push("/login");
        }

        if (response.status >= 500) {
          // this.setState({ error: "Something went wrong. Please check your internet connection and try again" });
        }
      })
      .catch(() => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "AutoRepaymentLoans.jsx (Download)",
          },
        });

        setDownloadLoading(false);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearch({ ...search, [name]: value, Page: 1, PageSize: 20 });
  };
  let RenderedComponent = null;
  if (!data && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Repayment
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = <Loader centered="true" text="Loading Repayment..." />;
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              repayment, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (data && data.data && data.data.length === 0) ||
      (data && !data.data)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no requests.
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="row m-x-sm m-y-2 grid__padding">
          <div className="table-responsive">
            <table className="table">
              <thead className="bg-lighter-grey">
                <tr>
                  <th>S/N</th>
                  <th>Reference</th>
                  <th>Loan Units</th>
                  <th>Amount Paid</th>
                  <th>Payment Date</th>
                  <th>Paid By</th>
                  <th>Status</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.map((data, id) => {
                  const {
                    reference,
                    amount,
                    dateRepaid,
                    message,
                    loanUnits,
                    repaymentStatusName,
                    name,
                  } = data;
                  return (
                    <tr key={id}>
                      <td>{id + 1}</td>
                      <td>{reference}</td>
                      <td>{loanUnits}</td>
                      <td>{formatMoney(amount)}</td>
                      <td>{dateRepaid?.substring(0, 10)}</td>
                      <td>{name}</td>
                      <td>
                        <span
                          className={attachClassNameToTag(repaymentStatusName)}
                        >
                          {repaymentStatusName}
                        </span>
                      </td>

                      <td>{message}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }

  return (
    <Fragment>
      <div className="dataTables_wrapper">
        <div
          id="activeEcosystem"
          className="Disbursement table-view animated speed-1x fadeInRight"
        >
          <form className="d-flex flex-row flex-wrap">
            <div style={{ marginBottom: "10px" }}>
              <CustomSelectDropdown
                onChange={(e) => handleChange(e)}
                name="Aggregator_Id"
                value={search.Aggregator_Id}
                className="round user__form form-control"
              >
                <option value="">search by aggregator</option>
                {aggregatorData &&
                  aggregatorData.map((aggregator) => {
                    const { biz_name, aggregator_id } = aggregator;
                    return (
                      <option value={Number(aggregator_id)} key={aggregator_id}>
                        {biz_name}
                      </option>
                    );
                  })}
              </CustomSelectDropdown>
            </div>
            <div style={{ marginBottom: "10px", width: "150px" }}>
              <CustomSelectDropdown
                // label="Loan Status"
                name="RepaymentStatus"
                value={search.RepaymentStatus}
                className="round user__form form-control"
                onChange={(e) => {
                  handleChange(e);
                }}
              >
                <option value="">Status</option>
                <option value={1}>Pending</option>
                <option value={2}>Successful</option>
              </CustomSelectDropdown>
            </div>
            {/* <div className="form-group inputWithIcon">
              <input
                type="text"
                className="round user__form form-control"
                placeholder="Ref"
                name="Reference"
                onChange={(e) => handleChange(e)}
                value={search.Reference}
              />
            </div> */}

            <div className="form-group mr-3 mt-2">
              <div className="input-group ">
                <label className="mr-2">From </label>
                <input
                  type="date"
                  name="DateRepaidFrom"
                  className="form-control"
                  value={search.DateRepaidFrom}
                  onChange={(e) => handleChange(e)}
                />
              </div>
            </div>
            <div className="form-group mt-2 mr-3">
              <div className="input-group">
                <label className="mr-2">To </label>
                <input
                  type="date"
                  className="form-control"
                  name="DateRepaidTo"
                  value={search.DateRepaidTo}
                  onChange={(e) => handleChange(e)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="btn advancly-btn btn-md"
                value="submit"
                disabled={status === "loading" || !data}
                onClick={() => setPresearch(search)}
              >
                Search
              </button>
              <button
                className="btn advancly-btn btn-md ml-2"
                onClick={handleDownload}
              >
                Download
              </button>
            </div>
          </form>

          {/*Datatable || Loader || Error Message*/}
          {RenderedComponent}
          <Paginator
            size={search.PageSize}
            page={search.Page}
            count={count}
            changeCurrentPage={(Page) => setSearch({ ...search, Page })}
          />
        </div>
      </div>
    </Fragment>
  );
}
export default AutoRepaymentLoans;
